export const request_lang={
  EN:{
    title:"Requesting Data",
    search_data:"search data",
    subject_text:"subject",
    username:"receiver",
    requestor:"requestor",
    saved:"Data was saved",
    deleted:"Data was deleted",
    add_request:"add request",
    edit_request:"edit request"
  },
  TH:{
    edit_request:"แก้ไขคำร้องเรียน",
    add_request:"แจ้งคำร้องเรียน",
    title:"ข้อมูลร้องเรียน",
    search_data:"ค้นหาข้อมูล",
    subject_text:"หัวข้อการร้องเรียน",
    username:"ผู้รับคำร้อง",
    requestor:"ผู้แจ้งคำร้อง",
    start_date:"วันเวลาเริ่มต้น",
    end_date:"วันเวลาสิ้นสุด",
    search:"ค้นหา",
    clear:"ล่าง",
    request_id:"รหัสการร้องเรียน",
    request_date:"วันที่แจ้งคำร้อง",
    edit:"แก้ไข",
    delete:"ลบ",
    cancel:"ยกเลืก",
    delete_title:"คุณต้องการลบข้อมูลนี้ใช่หรือไม่?",
    delete_warning:"ข้อมูลลบแล้วไม่สามารถยอนกลับได้!!",
    saved:"ข้อมูลถูกบันทึกกเรียบร้อยแล้ว",
    deleted:"ข้อมูลถูกลบเรียบร้อยแล้ว",
    detail:"รายละเอียด",
    "Add Request":"แจ้งคำร้อง",
    "back to request data":"กลับมาหน้าแสดงข้อมูลการร้องเรียน",
    save:"บันทึก",
    "please select subject":"กรุณาเลือกคำร้อง",
    "please select receiver":"กรุณาเลิอกผู้รับคำร้อง",
    "please input detail":"กรุณากรอกรายละเอียด",
    all:"ทั้งหมด",
    subject:"หัวข้อ"
  }
}
